<template>
  <div class="container">
    <b-modal no-close-on-backdrop centered ref="documento-modal" title="" hide-footer id="modalC" size="l">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putDocumento)">
          <ModalDocumento :optionsDocumentos="optionsDocumentosComputed" :currentDocumento="currentDocumento" @submit.prevent />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere eliminar el documento?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteDocumento">OK</b-button>
    </b-modal>

    <!-- <b-modal
      no-close-on-backdrop
      centered
      ref="modal-info-urgencia"
      hide-footer
      id="modal-info-urgencia"
      size="md"
      title="Información sobre urgencia"
    >
      <div class="p-2">
        <p>Se generarán cargos adicionales y no se pueden garantizar los tiempos de entrega.</p>
        Contenido de explicación de urgencia (pendiente de definir)
      </div>
      <b-button class="mt-3" variant="primary" block @click="$bvModal.hide('modal-info-urgencia')">Entendido</b-button>
    </b-modal> -->

    <b-modal no-close-on-backdrop id="modal-more-info" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-cotejos-1" :interval="0" controls indicators background="#ababab">
          <b-carousel-slide :img-src="require('@/assets/img/cotejos/help/2_4.webp')"></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <h4 class="cardD">Información de los Documentos</h4>

    <div class="mt-4">
      <label for="">Agregar documento</label>
      <b-button variant="success" class="btn-fill spaceL" size="sm" @click="addDocumento">+</b-button>
    </div>

    <div>
      <b-table ref="table" hover :fields="fieldsCuadro" :items="cotejo.documentos">
        <template #cell(acciones)="{ item }">
          <b-button variant="warning" size="sm" v-b-tooltip.hover title="Editar" class="editBtn" @click="editDocumento(item)">
            <b-icon-pencil />
          </b-button>
          <b-button variant="danger" size="sm" v-b-tooltip.hover title="Eliminar" @click="predeleteDocumento(item.id)">
            <b-icon-trash />
          </b-button>
        </template>
      </b-table>
    </div>

    <!-- Se oculta temporalmente -->
    <!-- <div class="row">
      <div class="col-md-12">
        <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem">
          <b-form-checkbox v-model="urgenciaComputed" :disabled="urgenciaNoAplica">
            Los documentos se requieren de urgencia
          </b-form-checkbox>
          <b-button variant="outline-primary" size="sm" class="ml-1" @click="$bvModal.show('modal-info-urgencia')">
            + Información
          </b-button>
        </div>
        <p v-if="urgenciaComputed" class="cardErrors">
          Se generarán cargos adicionales y no se pueden garantizar los tiempos de entrega.
        </p>
      </div>
    </div> -->

    <div class="row mb-3">
      <div class="col-md-12">
        <div style="display: flex; align-items: center">
          <b-form-checkbox v-model="envioDomicilioComputed" :disabled="urgenciaComputed">Envío a domicilio</b-form-checkbox>
        </div>
        <p v-if="envioDomicilioComputed" class="cardErrors">
          Al final del proceso podemos hacer llegar al domicilio que nos indiquen, tanto los originales que nos sean entregados
          para cotejo, como las copias certificadas expedidas. Este envío tiene costo adicional.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <b-button variant="outline-primary" size="sm" @click="$bvModal.show('modal-more-info')">
          + Información tiempos de entrega
        </b-button>
      </div>
    </div>

    <div class="mt-4">
      <div class="">
        <b-button class="btn-fill orange-btn bottom2" size="m" @click="checkDocumentos">Continuar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalDocumento from "@/views/clients/procesos/cotejo/infoBase/modales/ModalDocumento.vue";

import { CatDocumentosApi } from "@/api";
import loadingMixin from "@/mixins/loadingMixin";

export default {
  name: "Documentos",

  components: { ModalDocumento },

  props: {
    cotejo: { type: Object },
  },

  mixins: [loadingMixin],

  computed: {
    fieldsCuadro() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        { key: "paginas", label: "No. Páginas", class: "text-center" },
        { key: "copias_certificadas", label: "No. Copias", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },

    optionsDocumentosComputed() {
      const otro = this.optionsDocumentos.find((d) => d.id === 29);
      const arr = this.optionsDocumentos
        .filter((d) => ![29, 129].includes(d.id))
        .map((d) => ({ text: d.documento, value: d.id }))
        .sort((a, b) => a.text.localeCompare(b.text));

      if (otro) {
        arr.push({ text: otro.documento, value: otro.id });
      }

      return arr;
    },

    urgenciaComputed: {
      get() {
        return this.cotejo.id_prioridad === 1;
      },
      set(newValue) {
        this.cotejo.id_prioridad = newValue ? 1 : 2;
      },
    },

    envioDomicilioComputed: {
      get() {
        return this.cotejo.envio_domicilio === 1;
      },
      set(newValue) {
        this.cotejo.envio_domicilio = newValue ? 1 : 0;
      },
    },

    urgenciaNoAplica() {
      if (this.envioDomicilioComputed) {
        return true;
      }

      let countTieneAnexo = 0;
      for (let i = 0; i < this.cotejo.documentos.length; i++) {
        const documento = this.cotejo.documentos[i];
        if (!documento.hasOwnProperty("anexoDe")) {
          countTieneAnexo++;
          if (parseInt(documento.paginas) > 150 || parseInt(documento.paginas) + parseInt(documento.paginas_anexo) > 150) {
            return true;
          }
        }
      }

      return countTieneAnexo > 5;
    },
  },

  created() {
    this.getCatDocumentosCotejo();
  },

  data() {
    return {
      optionsDocumentos: [],

      selectedDocumento: null,
      currentDocumento: null,
      currentDocumentoId: null,

      id_anexo: 0,
    };
  },

  methods: {
    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async getCatDocumentosCotejo() {
      try {
        this.toggleOnLoading();
        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: "cotejos",
        });

        this.optionsDocumentos = value;
      } catch (error) {
        console.log(error);
      } finally {
        this.toggleOffLoading();
      }
    },

    addDocumento() {
      this.$refs["documento-modal"].show();
      this.currentDocumento = {};
    },

    putDocumento() {
      if (this.currentDocumento.descripcion) {
        this.currentDocumento.tipo = this.currentDocumento.descripcion;
      } else {
        const catDocumento = this.optionsDocumentos.find((d) => d.id === this.currentDocumento.catDocumentos_id);

        if (catDocumento) {
          this.currentDocumento.tipo = catDocumento.documento;
        }
      }

      if (!this.currentDocumento.id) {
        let id = this.cotejo.documentos.length + 1;
        this.currentDocumento.id = id;

        if (this.currentDocumento.urgencia) {
          this.cotejo.id_prioridad = 1;
        } else {
          this.cotejo.DocSinUrgencia = true;
        }

        this.cotejo.documentos.push(this.currentDocumento);
      }

      let index = this.cotejo.documentos.findIndex((o) => o.id === this.currentDocumento.id);
      this.cotejo.documentos[index].tipo = this.currentDocumento.tipo;

      if (this.currentDocumento.tiene_anexo) {
        this.addAnexo(this.currentDocumento, index + 1);
      } else {
        if (this.cotejo.documentos[index + 1]) {
          if (this.cotejo.documentos[index + 1].anexoDe) {
            this.cotejo.documentos.splice(index + 1, 1);
          }
        }
      }
      this.$refs.table.refresh();
      this.$refs["documento-modal"].hide();
    },

    editDocumento(item) {
      let documentoPadre = item;
      if (item.anexoDe) {
        this.cotejo.documentos.forEach((documento) => {
          if (documento.id == item.anexoDe) {
            documentoPadre = documento;
          }
        });
      }
      item = documentoPadre;
      this.$refs["documento-modal"].show();
      this.currentDocumento = item;
    },

    addAnexo(documento, index_to_slice) {
      let doc_urgencia = false;
      if (documento.urgencia) {
        doc_urgencia = true;
      }
      if (this.cotejo.documentos[index_to_slice]) {
        if (this.cotejo.documentos[index_to_slice].anexoDe) {
          this.cotejo.documentos.splice(index_to_slice, 1);
        }
      }
      const currentDocumento = {
        catDocumentos_id: this.id_anexo,
        paginas: documento.paginas_anexo,
        urgencia: doc_urgencia,
        tipo: "Anexo",
        anexoDe: documento.id,
      };
      this.cotejo.documentos.splice(index_to_slice, 0, currentDocumento);
    },

    predeleteDocumento(id) {
      this.currentDocumentoId = id;
      this.$refs["modal-confirm-dialog"].show();
    },

    deleteDocumento() {
      let index = this.cotejo.documentos.findIndex((o) => o.id === this.currentDocumentoId);
      if (this.cotejo.documentos[index].anexoDe) {
        this.cotejo.documentos.forEach((documento) => {
          if (documento.id == this.cotejo.documentos[index].anexoDe) {
            documento.tiene_anexo = false;
          }
        });
      }
      if (this.cotejo.documentos[index + 1]) {
        if (this.cotejo.documentos[index + 1].anexoDe) {
          this.cotejo.documentos.splice(index + 1, 1);
        }
      }
      this.cotejo.documentos.splice(index, 1);

      this.$refs["modal-confirm-dialog"].hide();
      this.$refs.table.refresh();
    },

    checkDocumentos() {
      if (this.cotejo.documentos.length == 0) {
        this.showErrorToast("Debe ingresar al menos 1 documento.");
        return;
      }
      this.$emit("allChecksPassed");
    },
  },
};
</script>
